module.exports = __webpack_public_path__ + "static/media/persona_f_60_03.be879904.png";